export function getInitials(firstName, lastName) {
  return [firstName, lastName]
    .filter(Boolean)
    .map((name) => name[0].toUpperCase())
    .join('');
}
